import { render } from "./MotorsportCrossSellPopup.vue?vue&type=template&id=b2fe1dc6&scoped=true"
import script from "./MotorsportCrossSellPopup.vue?vue&type=script&lang=js"
export * from "./MotorsportCrossSellPopup.vue?vue&type=script&lang=js"

import "./MotorsportCrossSellPopup.vue?vue&type=style&index=0&id=b2fe1dc6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2fe1dc6"]])

export default __exports__